import type { ICanvasRenderingContext } from '@babylonjs/core/Engines/ICanvas';

/**
 * Babylon's `ICanvasRenderingContext` is a deliberate subset of the DOM 2D context,
 * because Babylon also targets native and headless canvases. In a browser the object
 * really is a `CanvasRenderingContext2D`, so text metrics and baseline control are
 * available even though the interface omits them.
 */
export function as2d(context: ICanvasRenderingContext): CanvasRenderingContext2D {
  return context as unknown as CanvasRenderingContext2D;
}
